import React, { useState } from "react";
import Header from "../components/Header";
import VehiculeForm from "../components/Annonce/VehiculeForm";
import { useSelector } from "react-redux";
import Footer from "../components/Footer";
import LogementForm from "../components/Annonce/LogementForm";
import TerrainForm from "../components/Annonce/TerrainForm";
import FormationForm from "../components/Annonce/FormationForm";
import TravailForm from "../components/Annonce/TravailForm";
import AlimentationForm from "../components/Annonce/AlimentationForm";
import PlantesForm from "../components/Annonce/PlantesForm";
import AnimauxForm from "../components/Annonce/AnimauxForm";
import EquipementEvenementForm from "../components/Annonce/EquipementEvenementForm";
import EquipementMaisonForm from "../components/Annonce/EquipementMaison";
import MateriauxForm from "../components/Annonce/MateriauxForm";
import ArtisanatForm from "../components/Annonce/ArtisanatForm";
import Modal from "react-modal";
import Log from "../components/Log";

Modal.setAppElement("#root");

const CreateAnnonce = () => {
  const utilisateur = useSelector((state) => state.userReducer);

  const [selectedCategory, setSelectedCategory] = useState("Véhicule");

  const categories = [
    {
      name: "Véhicule et engins",
      component: <VehiculeForm utilisateurId={utilisateur?._id} />,
    },
    {
      name: "Logement",
      component: <LogementForm utilisateurId={utilisateur?._id} />,
    },
    {
      name: "Terrain",
      component: <TerrainForm utilisateurId={utilisateur?._id} />,
    },
    {
      name: "Formation",
      component: <FormationForm utilisateurId={utilisateur?._id} />,
    },
    {
      name: "Travail",
      component: <TravailForm utilisateurId={utilisateur?._id} />,
    },
    {
      name: "Alimentation",
      component: <AlimentationForm utilisateurId={utilisateur?._id} />,
    },
    {
      name: "Plantes",
      component: <PlantesForm utilisateurId={utilisateur?._id} />,
    },
    {
      name: "Animaux",
      component: <AnimauxForm utilisateurId={utilisateur?._id} />,
    },
    {
      name: "Équipement évènementiel",
      component: <EquipementEvenementForm utilisateurId={utilisateur?._id} />,
    },
    {
      name: "Équipement de la maison",
      component: <EquipementMaisonForm utilisateurId={utilisateur?._id} />,
    },
    {
      name: "Matériaux et outillage",
      component: <MateriauxForm utilisateurId={utilisateur?._id} />,
    },
        {
      name: "Artisanat",
      component: <ArtisanatForm utilisateurId={utilisateur?._id} />,
    },
  ];

  const [modalIsOpen, setModalIsOpen] = useState(false);

  const handleCategoryClick = (categoryName) => {
    setSelectedCategory(categoryName);
  };

  const currentComponent = categories.find(
    (cat) => cat.name === selectedCategory
  )?.component;

  return (
    <div>
      <Header />

      {utilisateur._id != null ? (
        <div className="createAnnonceContainer">
          <div className="zoneSelectCategorie">
            <select
              value={selectedCategory}
              onChange={(e) => handleCategoryClick(e.target.value)}
              className="selectCategory"
            >
              <option value="">Sélectionnez une catégorie</option>
              {categories.map((cat) => (
                <option key={cat.name} value={cat.name}>
                  {cat.name}
                </option>
              ))}
            </select>
          </div>

          <div className="zoneForm">{utilisateur && currentComponent}</div>
        </div>
      ) : (
        <>
          <p className="alertAuth">
            Authentifiez-vous pour pouvoir créer des annonces :{" "}
          </p>
          <p
            className="alertAuth openPop button"
            onClick={() => setModalIsOpen(true)}
          >
            Se connecter/S'inscrire
          </p>
          <Modal
            isOpen={modalIsOpen}
            onRequestClose={() => setModalIsOpen(false)}
            style={customStyles}
          >
            <button onClick={() => setModalIsOpen(false)}>Fermer</button>
            <Log />
          </Modal>
        </>
      )}

      <Footer />
    </div>
  );
};

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    padding: "2rem",
    borderRadius: "10px",
  },
};

export default CreateAnnonce;
